<div class="desktop">
  <div class="container">
    @if (!hideMenu) {
      <list-view-menu [options]="menuOptions" (action)="onMenu($event)"></list-view-menu>
    }
    <oph-button
      appearance="outline"
      color="gray"
      [style]="{color: 'var(--brown-med)', padding: '0 20px', fontWeight: '400'}"
      (click)="cancel.emit()"
      >Cancel</oph-button
    >
    <oph-button
      color="green"
      [style]="{'border-radius': '8px'}"
      [loading]="loading"
      [disabled]="loading"
      (click)="save.emit()"
      >Save</oph-button
    >
  </div>
</div>

<div class="mobile">
  @if (!hideMenu) {
    <list-view-menu [options]="menuOptions" (action)="onMenu($event)"></list-view-menu>
  }
  <button class="mobile-button cancel-button" (click)="cancel.emit()">Cancel</button>
  <button class="mobile-button save-button" (click)="save.emit()">
    <div class="save-button-inner-container">
      @if (loading) {
        <div class="oph-white-spinner">
          <mat-spinner [diameter]="24"></mat-spinner>
        </div>
      } @else {
        Save
      }
    </div>
  </button>
</div>
